<host-demo-page [demoImg]="img" [demoCardTitle]="demoCardTitle | translate" [demoCardDesc]="demoCardDesc | translate">
  <div class="demo-card-btns mt-[36px] flex flex-row">
    <a [routerLink]="[routes.ChannelAccount]">
      <button nz-button nzType="primary" nzSize="large">
        {{ demoCardBtn | translate }}
      </button>
    </a>

    <button nz-button nzSize="large" class="ml-4" (click)="onStartUse()">
      {{ 'default_page_html_start_to_use' | translate }}
      <!-- Start to use -->
    </button>
  </div>
</host-demo-page>
